import { createSelector } from '@reduxjs/toolkit';

import { selectCohortBuilderState } from './cohortBuilderEditModalSelectors';

export const selectConceptGroups = createSelector(
  selectCohortBuilderState,
  (cohortBuilderState) => cohortBuilderState?.conceptGroups
);
